// extracted by mini-css-extract-plugin
export default {"column":"CollectionCards_column__w-oOA"};